import aws_svg from "../assets/aws.svg";
import azure_svg from "../assets/Ally-Avatar.png";
import gcp_svg from "../assets/gcp.svg";
import psl_img from "../assets/psllogo_notitle.png";
import openai_svg from "../assets/openai.svg";
import ibm_svg from "../assets/ibm.svg";
import groq_svg from "../assets/groq.svg";
import nvidia_svg from "../assets/nvidia.svg";
import default_svg from "../assets/image.svg";

const data: { [index: string]: any } = {
  aws: aws_svg,
  bedrock: aws_svg,
  gcp: gcp_svg,
  gemini: gcp_svg,
  psl: psl_img,
  openai: openai_svg,
  watsonx: ibm_svg,
  ibm: ibm_svg,
  groq: groq_svg,
  azure: azure_svg,
  nvidia_nim: nvidia_svg,
  default: default_svg
};

export default data;
